module.exports = __webpack_public_path__ + "e4611594edde67ce98a87dbfab8bc36c.svg";